<div class="cell auto grid-y cell-block-y blockContent" *ngIf="study">
    <h2 class="_sansSerif _primary"[i18nKey]="'studies.potential.market.and.sales.explanations.title'"></h2>
    <kiwi-spacer [size]="16"></kiwi-spacer>
    <p><strong><span [i18nKey]="'studies.potential.market.and.sales.area.market.title'"></span> :</strong> <span [i18nKey]="'studies.potential.market.and.sales.area.market.description'"></span></p>
    <p><strong><span [i18nKey]="'studies.potential.market.and.sales.potential.market.title'"></span> :</strong> <span [i18nKey]="'studies.potential.market.and.sales.potential.market.description'"></span></p>
    <p><strong><span [i18nKey]="'studies.potential.market.and.sales.competition.density.title'"></span> :</strong> <span [i18nKey]="'studies.potential.market.and.sales.competition.density.description'"></span></p>
    <p><strong><span [i18nKey]="'studies.potential.market.and.sales.real.market.title'"></span> :</strong> <span [i18nKey]="'studies.potential.market.and.sales.real.market.description'"></span></p>
    <p><strong><span [i18nKey]="'studies.potential.market.and.sales.demands.title'"></span> :</strong> <span [i18nKey]="'studies.potential.market.and.sales.demands.description'"></span></p>
    <p><strong><span [i18nKey]="'studies.potential.market.and.sales.sales.title'"></span> :</strong> <span [i18nKey]="'studies.potential.market.and.sales.sales.description'"></span></p>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <div class="density">
        <span class="density-label"[i18nKey]="'studies.potential.market.and.sales.competition.density'"></span>
        <span class="density-value">{{study.competitionDensity | number:'1.2'}}</span>
    </div>

    <kiwi-spacer [size]="24"></kiwi-spacer>

    <canvas baseChart
            [datasets]="[{
              data: barChartData,
              label: ('studies.potential.market.and.sales.my.restaurant' | translate),
              backgroundColor: chartColors
            }]"
            [labels]="barChartLabels"
            [options]="barChartOptions"
            [plugins]="barChartPlugins"
            [legend]="true"
            [type]="barChartType"
            style="max-height:100%; align-self: center">
    </canvas>

    <kiwi-spacer [size]="24"></kiwi-spacer>

    <table class="cell shrink">
        <thead>
        <tr class="_titlePartTable">
            <th [i18nKey]="'studies.potential.market.and.sales.area.market'"></th>
            <th [i18nKey]="'studies.potential.market.and.sales.potential.market'"></th>
            <th [i18nKey]="'studies.potential.market.and.sales.real.market'"></th>
            <th [i18nKey]="'studies.potential.market.and.sales.demands'"></th>
            <th [i18nKey]="'studies.potential.market.and.sales.sales'"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td>
                {{study.areaMarketSize | number:'1.0'}}
            </td>
            <td>
                {{study.teamPotentialMarket | number:'1.0'}}
            </td>
            <td>
                {{study.teamRealMarket | number:'1.0'}}
            </td>
            <td>
                {{study.teamTotalDemands | number:'1.0'}}
            </td>
            <td>
                {{study.teamTotalSales | number:'1.0'}}
            </td>
        </tr>
        </tbody>
    </table>
</div>
